module.exports = __webpack_public_path__ + "media/metronic/_theme/media/plugins/jstree/32px-e1d0c01e695c145fdd66ecc07e06268e.png";